import Link from 'next/link';
import { ReactNode } from 'react';
import Facebook from '../../../svg/Socials/Facebook.svg';
import Instagram from '../../../svg/Socials/Instagram.svg';
import TikTok from '../../../svg/Socials/TikTok.svg';
import YouTube from '../../../svg/Socials/YouTube.svg';
import styles from './footer.module.css';

const footerSocials = [
  {
    title: 'Facebook',
    className: styles.socialLink,
    href: 'https://www.facebook.com/daymadeuk/',
    icon: (
      <>
        <Facebook />
      </>
    ),
  },
  {
    title: 'Instagram',
    className: styles.socialLink,
    href: 'https://www.instagram.com/daymadeuk/',
    icon: (
      <>
        <Instagram />
      </>
    ),
  },
  {
    title: 'YouTube',
    className: styles.socialLink,
    href: 'https://www.youtube.com/channel/UCUVOk8dVM_mu-1qgKwtn9HA',
    icon: (
      <>
        <YouTube />
      </>
    ),
  },
  {
    title: 'TikTok',
    className: styles.socialLink,
    href: 'https://www.tiktok.com/@daymadeuk',
    icon: (
      <>
        <TikTok />
      </>
    ),
  },
];

const SocialLink = ({
  id,
  title,
  className,
  href,
  icon,
}: {
  id?: string;
  title?: string;
  className?: string;
  href: string;
  icon: ReactNode;
}) => {
  return (
    <Link
      id={id}
      className={className}
      href={href}
      title={title}
      aria-label={title}
      target="_blank"
      rel="noreferrer"
    >
      {icon}
    </Link>
  );
};

const SocialLinks = () => {
  return (
    <>
      {footerSocials.map((item) => (
        <SocialLink
          key={item.title}
          id={`${item.title?.toLowerCase()}ext`}
          title={item.title}
          className={item.className}
          href={item.href}
          icon={item.icon}
        />
      ))}
    </>
  );
};

export default SocialLinks;
